import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, Category, PaginatedResponse, PaginationQuery } from '../types/api';

export interface CategoryInput { name: string; description?: string; }
export interface CategoryQuery extends PaginationQuery { active?: boolean; }

export async function listCategories(query: CategoryQuery = {}) {
  const response = await api.get<PaginatedResponse<Category>>(`/categories${toQueryString(query)}`);
  return response.data;
}
export async function createCategory(input: CategoryInput) {
  const response = await api.post<ApiResponse<Category>>('/categories', input);
  return response.data.data;
}
export async function getCategory(id: number) {
  const response = await api.get<ApiResponse<Category>>(`/categories/${id}`);
  return response.data.data;
}
export async function updateCategory(id: number, input: Partial<CategoryInput>) {
  const response = await api.patch<ApiResponse<Category>>(`/categories/${id}`, input);
  return response.data.data;
}
export async function updateCategoryStatus(id: number, active: boolean) {
  const response = await api.patch<ApiResponse<Category>>(`/categories/${id}/status`, { active });
  return response.data.data;
}
